export { useTelefuncAbort }

import { useEffect } from 'react'
import { onAbort } from 'telefunc/client'
import { isNotLoggedInAbort } from './abortValue.ts'
import { logoutAndReload } from './logoutAndReload.ts'

// When a server telefunc throws `Abort({ notLoggedIn: true })` — the signal that the auth
// cookie no longer verifies — clear the HttpOnly cookie via the server and reload, which
// lands the user back on <Login>. Mount once at the page root; `onAbort` returns the
// listener-removal cleanup.
function useTelefuncAbort(): void {
  useEffect(() => {
    return onAbort(async (err) => {
      if (!isNotLoggedInAbort(err)) return
      await logoutAndReload()
    })
  }, [])
}
